module.exports = __webpack_public_path__ + "img/img_15.fad3877a.png";